import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("anuswa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve image url: seeded products use absolute urls; uploads return /api/... paths
export const imgUrl = (u) => {
  if (!u) return undefined;
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const rupee = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
